<template>
	<el-dialog
		append-to-body
		destroy-on-close
		:before-close="
			(setDialogHide) => {
				handleCloseDialog(setDialogHide, isFormDirty);
			}
		"
		class="custom-dialog"
		:visible.sync="isPopupActiveLocal"
	>
		<div slot="title">
			<h4 class="uppercase font-bold block text-xl w-full">Thông tin vận chuyển</h4>
			<!-- <p class="text-base text-black font-medium">{{ data.device ? data.device.name : "" }}</p> -->
		</div>
		<!--<PerfectScrollbar ref="formScrollBar" class="scroll-area--data-list" :settings="settings">-->
		<div>
			<div class="p-6" v-if="isPopupActiveLocal">
				<div class="mb-5">
					<label for class="text-base vs-input--label">
						Thời gian giao hàng dự kiến
						<span class="text-danger">*</span>:
					</label>
					<CbsDatePicker value-format="yyyy-MM-dd HH:mm" name="shipping_date" :data-vv-as="'Thời gian'" class="w-full" v-model="shipping_date" type="datetime" placeholder="Chọn thời gian giao" :picker-options="pickerOptions" v-validate="'required'" />
					<span class="text-danger text-sm break-normal" v-show="errors.has('shipping_date')">{{ errors.first("shipping_date") }}</span>
				</div>
				<div class="mb-5">
					<label for class="text-base vs-input--label">
						Khối lượng (kg)
						<span class="text-danger">*</span>:
					</label>
					<cbs-input type="number" v-model="quantity" class="w-full" name="quantity" :data-vv-as="'Khối lượng'" :placeholder="`${$t('Input')} ${'Khối lượng'}`" v-validate="'required'" />
					<span class="text-danger text-sm break-normal" v-show="errors.has('quantity')">{{ errors.first("quantity") }}</span>
				</div>
				<div class="mb-5">
					<label for class="text-base vs-input--label">
						Số bao:
					</label>
					<cbs-input type="number" v-model="num_packaging" class="w-full" name="num_packaging" :data-vv-as="'Số bao'" :placeholder="`${$t('Input')} ${'Số bao'}`" />
					<span class="text-danger text-sm break-normal" v-show="errors.has('num_packaging')">{{ errors.first("num_packaging") }}</span>
				</div>
				<div class="mb-5">
					<label for class="text-base vs-input--label">
						Loại phương tiện
						<span class="text-danger">*</span>:
					</label>
					<v-select
						:clearable="false"
						class="border-none w-full"
						:placeholder="`Chọn phương thức`"
						v-model="vehicle_type"
						name="vehicle_type"
						:options="shippingMethodTypes"
						:reduce="(p) => p.id"
						label="name"
						:data-vv-as="'Phương thức'"
						v-validate="'required'"
						required="true"
					/>
					<span class="text-danger text-sm break-normal" v-show="errors.has('vehicle_type')">{{ errors.first("vehicle_type") }}</span>
				</div>
				<div class="mb-5">
					<label for class="text-base vs-input--label">
						Biển số
						<span class="text-danger">*</span>:
					</label>
					<cbs-input type="text" v-model="vehicle_no" class="w-full" name="vehicle_no" :data-vv-as="'Biển số'" :placeholder="`${$t('Input')} ${'Biển số. Ví dụ: 66A1 666.66'}`" v-validate="'required'" />
					<span class="text-danger text-sm break-normal" v-show="errors.has('vehicle_no')">{{ errors.first("vehicle_no") }}</span>
				</div>
				<div class="mb-5">
					<label for class="text-base vs-input--label">
						Tài xế
						<span class="text-danger">*</span>:
					</label>
					<cbs-input type="text" v-model="driver_name" class="w-full" name="driver_name" :data-vv-as="'Tài xế'" :placeholder="`${'Tài xế'}`" v-validate="'required'" />
					<span class="text-danger text-sm break-normal" v-show="errors.has('driver_name')">{{ errors.first("driver_name") }}</span>
				</div>
				<div class="mb-5">
					<label for class="text-base vs-input--label">
						Điện thoại tài xế
						<span class="text-danger">*</span>:
					</label>
					<cbs-input type="text" v-model="driver_phone" class="w-full" name="driver_phone" :data-vv-as="'Điện thoại tài xế'" :placeholder="`${'Điện thoại tài xế'}`" v-validate="'required'" />
					<span class="text-danger text-sm break-normal" v-show="errors.has('driver_phone')">{{ errors.first("driver_phone") }}</span>
				</div>
				<div class="mb-5">
					<label for class="text-base vs-input--label">
						Điểm đến
						<span class="text-danger">*</span>:
					</label>
					<cbs-input type="text" v-model="shipping_address" class="w-full" name="shipping_address" :data-vv-as="'Điểm đến'" :placeholder="`${$t('Input')} ${'Điểm đến'}`" v-validate="'required'" />
					<span class="text-danger text-sm break-normal" v-show="errors.has('shipping_address')">{{ errors.first("shipping_address") }}</span>
				</div>
			</div>
		<!--</PerfectScrollbar>-->
		</div>

		<div class="flex justify-center" slot="footer">
			<vs-button class="w-full sm:w-1/3 font-bold" @click.stop="submitData" >Lưu lại</vs-button>
		</div>
	</el-dialog>
</template>
<script>
import * as _ from "lodash";
import vSelect from "vue-select";
import CbsDatePicker from "@/components/cbs-date-picker/CbsDatePicker.vue";

export default {
	name: "ShippingForm",
	components: { vSelect, CbsDatePicker },
	props: {
		isPopupActive: {
			type: Boolean,
			required: true,
		},
		data: {
			type: Object,
			default: () => {},
		},
	},
	data() {
		return {
			shippingMethodTypes: [
				{
					id: 1,
					name: 'Xe tải'
				},
				{
					id: 2,
					name: 'Ghe'
				},
				{
					id: 4,
					name: 'Xe ba gác'
				},
			],
			shipping_date: null,
			vehicle_type: null,
			vehicle_no: null,
			driver_name: null,
			shipping_address: null,
			num_packaging: null,
			driver_phone: null,


			timeKey: Date.now(),
			files: [],
			value: {},
			product: null,
			supplier: null,
			quantity: null,
			price: null,
			address: null,
			cus_note: null,

			'supplier_name': null,
            'supper_phone': null,
            'supper_mst': null,
            'supplier_bankaccount': null,
            'supplier_bankname': null,
            'supplier_bankowner': null,

			id: null,
			match_id: null,

			fullName: null,
			nickname: null,
			phone: null,
			city: null,
			district: null,
			ward: null,
			street: null,
			assigned: null,
			totalPool: null,

			settings: {
				// perfectscrollbar settings
				maxScrollbarLength: 60,
				wheelSpeed: 0.6,
			},
			pickerOptions: {
				// disabledDate(time) {
				// 	return time.getTime() <= Date.now();
				// }
			}
		};
	},
	watch: {
		isPopupActive(val) {
			if (!val) return;

			const { id, buy_address, address, match_id, vehicle_no, vehicle_type, quantity, driver_name, shipping_date, driver_phone, num_packaging } = this.data;
			console.log(this.data);
			if (id) {
				this.id = id;
			} else {
				this.id = null;
			}
			if (match_id) {
				this.match_id = match_id;
			} else {
				this.match_id = null;
			}
			if (address) {
				this.shipping_address = address;
			} else if (buy_address) {
				this.shipping_address = buy_address;
			} else {
				this.shipping_address = null;
			}
			if (vehicle_no) {
				this.vehicle_no = vehicle_no;
			} else {
				this.vehicle_no = null;
			}
			if (vehicle_type) {
				this.vehicle_type = vehicle_type;
			} else {
				this.vehicle_type = null;
			}
			if (quantity) {
				this.quantity = quantity;
			} else {
				this.quantity = null;
			}
			if (num_packaging) {
				this.num_packaging = num_packaging;
			} else {
				this.num_packaging = null;
			}
			if (driver_phone) {
				this.driver_phone = driver_phone;
			} else {
				this.driver_phone = null;
			}
			if (driver_name) {
				this.driver_name = driver_name;
			} else {
				this.driver_name = null;
			}
			if (shipping_date) {
				this.shipping_date = shipping_date;
			} else {
				this.shipping_date = null;
			}

			this.isFormDirty = false;
			this.initFormData = {};
		},

		computedFormData: {
			handler: function (newVal) {
				if (!this.isFormDirty && !_.isEqual(newVal, this.initFormData) && newVal.id === this.initFormData.id) {
					this.isFormDirty = true;
				}
			},
			deep: true,
		},
		city() {
			if (this.city) {
				this.$store.dispatch("getDistrict", {
					provinceCode: this.city,
				});
			}
		},
		district() {
			if (this.district) {
				this.$store.dispatch("getWard", {
					districtCode: this.district,
				});
			}
		},
	},
	computed: {
		localAttachFile: {
			get() {
				console.log('this.value: ' , this.value);
				return this.value.attachFile ? [this.value.attachFile] : [];
			},
			set(val) {
				console.log('set.value: ' , val);
				console.log(typeof val);
				if (val.length) {
					this.files = val;
				} else if (typeof val === 'number') {
					this.files.splice(val, 1);
				}
				return this.$emit("input", { ...this.value, attachFile: val && val.length ? val[0] : null });
			}
		},
		isPopupActiveLocal: {
			get() {
				return this.isPopupActive;
			},
			set(val) {
				if (!val) {
					this.$emit("closePopup");
				}
			},
		},
		computedFormData() {
			return {
				id: this.id,
				fullName: this.fullName,
				nickname: this.nickname,
				phone: this.phone,
				city: this.city,
				district: this.district,
				ward: this.ward,
				street: this.street,
				assigned: this.assigned,
				totalPool: this.totalPool,
			};
		},
	},
	created() {
		this.getSuppliers();
		if (this.$store.state.AppActiveUser) {
			let { permissions = {}, token } = this.$store.state.AppActiveUser;
			let { shipping_can_create = false, shipping_can_done = false, shipping_can_rating = false } = permissions;
			if (shipping_can_create) {
				this.canCreateShipping = true;
			}
			if (shipping_can_done) {
				this.canDoneShipping = true;
			}
			if (shipping_can_rating) {
				this.canRatingShipping = true;
			}
		}
	},
	methods: {
		getSuppliers() {
			// this.$vs.loading();
			try {
				let payload = {
				};
				this.$store.dispatch("moduleProduct/fetchSuppliers", payload);
				this.getGetUsers();
				// this.$vs.loading.close();
			} catch (error) {
				console.log(error.message);
				// this.$vs.loading.close();
			}
		},
		handleChangeFile(uploadedFiles) {
			console.log('handleChangeFile: ', uploadedFiles);
			const uploadResult = uploadedFiles.map(file =>
				_.get(file, "response")
					? {
							id: file.response.id,
							path: file.response.path,
							file_name: file.response.file_name,
							extension: file.response.extension
					  } // eslint-disable-line no-mixed-spaces-and-tabs
					: file
			);

			this.value.attachFile = uploadResult && uploadResult.length ? uploadResult[0] : null;
		},
		initValues() {
			this.shipping_date = null;
			this.quantity = null;
			this.supper_mst = null;
			this.vehicle_type = null;
			this.vehicle_no = null;
			this.driver_name = null;
			this.shipping_address = null;
			this.driver_phone = null;
			this.num_packaging = null;
			this.$validator.reset();
		},
		submitData() {
			this.$validator.validateAll().then((result) => {
				if (result) {
					const dataObj = {
						id: this.id,
						match_id: this.match_id,
						shipping_date: this.shipping_date,
						quantity: this.quantity,
						vehicle_type: this.vehicle_type,
						vehicle_no: this.vehicle_no,
						driver_name: this.driver_name,
						shipping_address: this.shipping_address,
						num_packaging: this.num_packaging,
						driver_phone: this.driver_phone,
					};
					console.log("[SUBMIT]", dataObj);

					this.handleCreateOrUpdate(dataObj);
				}
			});
		},
		handleCreateOrUpdateSuccess() {
			if (this.supplier == 0) {
				this.getSuppliers();
			}
			if (!this.id) {
				this.initValues();
			}
			// if (this.id) {
			// 	this.$emit("closePopup");
			// }
			this.isFormDirty = false;
			this.$helper.notifySuccess({
				context: this,
				options: {
					text: "Lưu thành công",
				},
			});
		},
		async handleCreateOrUpdate(dataObj) {
			try {
				this.$vs.loading();
				await this.$store.dispatch("moduleProduct/saveShipping", dataObj);
				this.handleCreateOrUpdateSuccess();
			} catch (error) {
				console.log(error);
				this.$helper.notifyError({ context: this, options: {
					text: error,
				} });
			} finally {
				this.$vs.loading.close();
			}
		},

		getAddressCodeAndName(listData, code) {
			return _.find(listData, function (add) {
				return add.code === code;
			});
		},
	},
};
</script>
